module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/autobackground@2x.png?1.0.17";